<template>
  <router-view v-if="isRouterActive"></router-view>
</template>

<script setup>
import { nextTick, provide, ref } from "vue";

const isRouterActive = ref(true);

let lang = localStorage.getItem("lang");
if (!lang) {
  localStorage.setItem("lang", "zh");
  location.reload();
}

const reload = () => {
  isRouterActive.value = false;
  nextTick(() => {
    isRouterActive.value = true;
  });
};

provide("reload", reload);
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
